import { isMobileUser } from './utils';

function manipulateRowClass() {
	let isMobile = isMobileUser()
	const adbannerBottom = document.getElementById('ab-bottom')

	if (isMobile && adbannerBottom)
		if (adbannerBottom.classList.contains('row'))
			adbannerBottom.classList.remove('row')
		else if (!adbannerBottom.classList.contains('row'))
			adbannerBottom.classList.add('row')
}

window.addEventListener('load', manipulateRowClass())